const BASE = '/images/groups-icons'

export const ICONE_TODOS = `${BASE}/todosProdutos.webp`
export const ICONE_DESTAQUE = `${BASE}/destaque.webp`

const ICONE_POR_TIPO: Record<string, string> = {
    almocos: 'almocos.webp',
    batataFrita: 'batataFrita.webp',
    bordasPizzas: 'bordasPizzas.webp',
    cachorroQuente: 'cachorroQuente.webp',
    cafes: 'cafes.webp',
    cakes: 'cakes.webp',
    cervejas: 'cervejas.webp',
    chop: 'chop.webp',
    cigarros: 'cigarros.webp',
    combo: 'combo.webp',
    comidas: 'comidas.webp',
    croissant: 'croissant.webp',
    fastFood: 'fastFood.webp',
    grelhados: 'grelhados.webp',
    hamburguer: 'hamburguer.webp',
    hashis: 'hashis.webp',
    outrasBebidas: 'outrasBebidas.webp',
    outrosProdutos: 'outrosProdutos.webp',
    pasta: 'pasta.webp',
    pasteis: 'pasteis.webp',
    pizzas: 'pizzas.webp',
    porcoes: 'porcoes.webp',
    pratosLaCarte: 'pratosLaCarte.webp',
    refrigerantes: 'refrigerantes.webp',
    saboresPizzas: 'saboresPizzas.webp',
    salada: 'salada.webp',
    shawarma: 'shawarma.webp',
    sobremesas: 'sobremesas.webp',
    sopas: 'sopas.webp',
    sorvetes: 'sorvetes.webp',
    steak: 'steak.webp',
    sucos: 'sucos.webp',
    sushis: 'sushis.webp',
    taxasServicos: 'taxasServicos.webp',
    whisky: 'whisky.webp',
    wine: 'wine.webp',
}

export function iconeGrupo(tipo: string | null | undefined): string | null {
    if (!tipo) return null

    const arquivo = ICONE_POR_TIPO[tipo.trim()]

    return arquivo ? `${BASE}/${arquivo}` : null
}

export function todosOsIcones(): string[] {
    return [ICONE_TODOS, ICONE_DESTAQUE, ...Object.values(ICONE_POR_TIPO).map((arquivo) => `${BASE}/${arquivo}`)]
}
